import React from 'react';
import styled from 'styled-components';
import sezzleTheme from '../../templates/Page/themes';

export interface Props {
  /** List of obajects containing elements with info for link list */
  elements: Record<string, any>[];
  /** Slug of the page */
  slug: string;
}

const StyledUl = styled.ul`
  padding-bottom: 40px;
  li {
    text-align: center;
  }

  a {
    font-family: ${sezzleTheme.bodyFont};
    color: ${sezzleTheme.textColor};
  }
  a:hover {
    color: ${sezzleTheme.linkColorHover};
  }
`;

const baseUrl = process.env.GATSBY_BASE_URL;

const PagesLinkList = ({ elements, slug }: Props) => {
  const slugPrefix = React.useMemo(() => {
    return slug.split('/')[0];
  }, [slug]);

  return !!elements ? (
    <StyledUl className="link-list">
      {elements.map((e) => {
        return (
          <li>
            <a href={`${baseUrl}/${slugPrefix}/${e.id}/`}>{e.name}</a>
          </li>
        );
      })}
    </StyledUl>
  ) : null;
};

export default PagesLinkList;
